import React from 'react';
import { Grid, Typography, CardContent } from '@mui/material';
import { StyledCard, ImageWithPreview } from './shared';
import { getHTTPUrlFromS3Path } from '../../../utils/outputs';

interface Deviation {
  mode: string;
  images: string[];
  floorplan_id: string;
}

interface DeviationsSectionProps {
  deviations: Deviation[];
}

const DeviationsSection: React.FC<DeviationsSectionProps> = ({ deviations }) => {
  if (!deviations?.length) return null;
  return (
    <Grid item xs={12}>
      <Typography variant="h2" sx={{ mb: 2 }}>Deviations</Typography>
      <Grid container spacing={2}>
        {deviations.map((deviation, index) => (
          <Grid item xs={12} md={12} key={index}>
            <StyledCard>
              <CardContent>
                <Typography variant="h3">{deviation.mode.toLowerCase() === '2d' ? '2D Deviation' : '3D Deviation'}</Typography>
              </CardContent>
              <Grid container spacing={1}>
                {deviation.images.map((image, imgIndex) => (
                  <Grid item xs={6} key={imgIndex}>
                    <ImageWithPreview
                      src={(url => url.endsWith('/') ? url.slice(0, -1) : url)(getHTTPUrlFromS3Path(image))}
                      alt={`Deviation ${index + 1} - Image ${imgIndex + 1}`}
                      identifier={`deviation-${index}-${imgIndex}`}
                    />
                  </Grid>
                ))}
              </Grid>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default DeviationsSection;
